import contentRequest from '~/src/api/requests/contentRequest';
import { captureQueryError, TResponse } from '~/src/api/helper';

export interface IMenuItem {
    id: number;
    title: string;
    link: string;
    weight: number;
    desc?: string;
    add_desc?: string;
    image: string;
    css_icon: unknown;
    available: 1 | 0
    parent: 1 | 0;
    parent_id: unknown;
    view: 0 | 1 | 2;
    menu_type: string;
    promoted: 1 | 0;
    button_link?: string;
    button_text?: string;
    promo_title?: string;
    promo_link?: string;
    promo_description?: string;
    children?: IMenuItem[];
}

export type TMenuDataResponse = TResponse<Record<string, IMenuItem>, any>;

export const getMenu = async(domainCity: string, abnVariant?: number): Promise<TMenuDataResponse> => {
    const url = `${domainCity}/v2/menu`;
    const params = abnVariant ? { abnVariant } : {};

    try {
        const response = await contentRequest.getWithCache(url, {
            params,
        });
        return {
            isSuccess: true,
            payload: response.data
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
